/* eslint-disable react/no-children-prop */

import React from 'react';
import { browserHistory, Router } from 'react-router';
import { Provider } from 'react-redux';
import { LocaleProvider } from 'antd';
import enUS from 'antd/lib/locale-provider/en_US';
import PropTypes from 'prop-types';


export default class App extends React.Component {
  static propTypes = {
    store: PropTypes.shape().isRequired,
    routes: PropTypes.shape().isRequired,
  };

  shouldComponentUpdate() {
    return false;
  }

  render() {
    return (
      <Provider store={this.props.store}>
        <LocaleProvider locale={enUS}>
          <Router history={browserHistory} children={this.props.routes} />
        </LocaleProvider>
      </Provider>
    );
  }
}



// WEBPACK FOOTER //
// /Users/balazskaxd/dev/rkk/rkk-webapp/src/components/App.js